import { ptPlusVendorPricingList } from "redux/actions/adminPTPlusVendorPricing";

const getPalletDetails = (data) => {
  let material = data?.material
  let condition = data?.condition?.join()
  let hardOrSoftWood = data?.newConditionType === 'HARDWOOD' ? '(HW)' : data?.hardOrSoftWood === 'SOFTWOOD' ? '(SW)' : ''
  let palletType = data?.palletType
  let moisture = data?.moisture
  let size = data?.size
  let grade = data?.grade
  let dimensions = (data?.length && data?.length !== "") ? `${data?.length}x${data?.width}x${data?.height}` : ''

  let resultString = [material, condition ? `${condition} ${hardOrSoftWood}`.trim() : '', palletType, moisture, size, grade, dimensions].filter(item => item).join('-');
  return resultString?.replace(/,|\n|\r/g, " ")
}
const prepareCsvData = (vendorPricingFeeData) => {
  let tempCsvData = vendorPricingFeeData.flatMap(item => {
    let mainDataRow = [];
    item.vendors.forEach(vendor => {
      if (vendor.feeDetails.length > 0) {
        vendor.feeDetails.forEach(feeDetail => {
          mainDataRow.push({
            VendorPricingFeeId: item.id || "NA",
            CustomerName: item.customerName?.replace(/,|\n|\r/g, " ") || "NA",
            CustomerLocationName: item.customerLocationName?.replace(/,|\n|\r/g, " ") || "NA",
            City: item.city || "NA",
            State: item.state || "NA",
            Vendor: `${vendor.vendorLocationName?.replace(/,|\n|\r/g, " ")}-${vendor.city}-${vendor.state}` || "NA",
            PalletDetails: getPalletDetails(feeDetail.palletDetails),
            Equipment: feeDetail?.equipment || 'NA',
            VendorFee: `$${feeDetail?.vendorFee?.toFixed(2)}` || "NA",
            CustomerFee: `$${feeDetail?.customerFee?.toFixed(2)}` || "NA",
            StartDate: feeDetail.rateStartDate || "NA",
            EndDate: feeDetail.rateExpirationDate || "NA",
            Comment: feeDetail?.comment && feeDetail.comment?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || 'NA'
          });
        });
      } else {
        mainDataRow.push({
          VendorPricingFeeId: item.id || "NA",
          CustomerName: item.customerName || "NA",
          CustomerLocationName: item.customerLocationName || "NA",
          City: item.city || "NA",
          State: item.state || "NA",
          Vendor: `${vendor.vendorLocationName?.replace(/,|\n|\r/g, " ")}${vendor.city?.replace(/,|\n|\r/g, " ") ? `- ${vendor.city?.replace(/,|\n|\r/g, " ")}` : ''}${vendor.state ? `- ${vendor.state}` : ''}` || "NA",
          PalletDetails: "NA",
          Equipment: "NA",
          VendorFee: "NA",
          CustomerFee: "NA",
          StartDate: "NA",
          EndDate: "NA",
          Comment: "NA"
        });
      }
    });
    return mainDataRow;
  });

  return tempCsvData;
}


let csvFinalData = [];
const handlePtPlusVendorPricingCsvExportClick = async (filter, tableSearch, setIsDownloadingPtPlusVendorPricingCSV, setPtPlusCsvVendorPricingReportData, ptPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvTotalPages, dispatch) => {
  let data = {
    size: 100,
    number: ptPlusVendorPricingCsvCurrentPage,
    sort: "ASC",
    searchCriteria: {
      customerIds: filter?.customerIds?.length > 0 ? filter?.customerIds : null,
      locationIds: filter?.locationIds?.length > 0 ? filter?.locationIds : null,
      vendorIds: filter?.vendorIds?.length > 0 ? filter?.vendorIds : null,
      searchBy: tableSearch || null,
      active: filter.active
    }
  }
  const token = localStorage.getItem("token")
  let response = await dispatch(ptPlusVendorPricingList(data, token));
  if (response?.success) {
    let resultApiData = response?.data?.deliveryPricingList
    if (resultApiData === null) resultApiData = []
    const totalPages = response?.data?.totalPages ?? 1;
    setPtPlusVendorPricingCsvTotalPages(totalPages)
    csvFinalData.push(...resultApiData)

    if (totalPages > ptPlusVendorPricingCsvCurrentPage + 1) {
      const nextPage = ptPlusVendorPricingCsvCurrentPage + 1;
      setPtPlusVendorPricingCsvCurrentPage(nextPage)

      handlePtPlusVendorPricingCsvExportClick(filter, tableSearch, setIsDownloadingPtPlusVendorPricingCSV, setPtPlusCsvVendorPricingReportData, nextPage, setPtPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvTotalPages, dispatch)
      return;
    }

    const preparedCsvData = prepareCsvData(csvFinalData)
    setIsDownloadingPtPlusVendorPricingCSV(false)
    setPtPlusCsvVendorPricingReportData(preparedCsvData);

    const ptPlusVendorPricingCsvExportRef = document.querySelector("#ptPlusVendorPricingCsvExportRef")
    if (ptPlusVendorPricingCsvExportRef) {
      setTimeout(() => {
        ptPlusVendorPricingCsvExportRef.click();
      }, 500);
    }
  } else {
    setIsDownloadingPtPlusVendorPricingCSV(false)
  }
}

export const ExportPtPlusVendorPricingReport = (filter, tableSearch, setIsDownloadingPtPlusVendorPricingCSV, setPtPlusCsvVendorPricingReportData, ptPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvTotalPages, dispatch) => {
  setIsDownloadingPtPlusVendorPricingCSV(true)
  csvFinalData = [];
  handlePtPlusVendorPricingCsvExportClick(filter, tableSearch, setIsDownloadingPtPlusVendorPricingCSV, setPtPlusCsvVendorPricingReportData, ptPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvTotalPages, dispatch)
}

export const ptPlusVendorPricingCSVHeaderArray = [
  { id: 'VendorPricingFeeId', displayName: 'Vendor Pricing Fee Id' },
  { id: 'CustomerName', displayName: 'Customer Name' },
  { id: 'CustomerLocationName', displayName: 'Customer Location' },
  { id: 'City', displayName: 'City' },
  { id: 'State', displayName: 'State' },
  { id: 'Vendor', displayName: 'Vendor Pricing Vendor' },
  { id: 'PalletDetails', displayName: 'Pallet Details' },
  { id: 'Equipment', displayName: 'Equipment' },
  { id: 'VendorFee', displayName: 'Vendor Price' },
  { id: 'CustomerFee', displayName: 'Customer Price' },
  { id: 'StartDate', displayName: 'Start Date' },
  { id: 'EndDate', displayName: 'End Date' },
  { id: 'Comment', displayName: 'Comment' },
];